var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.66663L2.66659 2.66663C1.92659 2.66663 1.33992 3.25996 1.33992 3.99996L1.33325 12C1.33325 12.74 1.92659 13.3333 2.66659 13.3333H13.3333C14.0733 13.3333 14.6666 12.74 14.6666 12V3.99996C14.6666 3.25996 14.0733 2.66663 13.3333 2.66663ZM13.3333 12H2.66659L2.66659 7.99996L13.3333 7.99996V12ZM13.3333 5.33329L2.66659 5.33329V3.99996L13.3333 3.99996V5.33329Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a5ca4b333479e9f9d7fd014c4164ea0a.svg";
export { ForwardRef as ReactComponent };